import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getPayRateMarketByLocationCsv } from 'api/pulse/payRateMarketByLocation'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function usePayRateMarketByLocationDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_pay_rate_market_by_location', {
        filters: query,
      })
      const data = await getPayRateMarketByLocationCsv(query)
      fileDownload(data, 'pay_rate_market_by_location.csv')
    },
  })
}
